var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 6.167c.692 0 1.252.56 1.252 1.25a1.252 1.252 0 01-2.505 0c0-.69.561-1.25 1.253-1.25zm.833 10.729c0 .518-.372.937-.833.937-.46 0-.833-.419-.833-.937V11.27c0-.519.372-.938.833-.938.46 0 .833.42.833.938v5.625zM12 22c5.514 0 10-4.486 10-10S17.514 2 12 2 2 6.486 2 12s4.486 10 10 10z",
    fill: "#fff"
  })));
}
SvgPrInfo.displayName = 'PrInfo';
export default SvgPrInfo;